<a class="map-button" [ngClass]="{ 'map-button--square': square }" [href]="href" target="_blank">
  <ng-content></ng-content>
</a>
